import React from 'react'
import { Articles, Footer, Header, Skills, Work, Reviews } from './container'
import { Navbar } from './components'
import './App.scss'

const App = () => {
  return (
    <div className="app">
        <Navbar />
        <Header />
        {/* <About /> */}
        <Work />
        <Skills />
        {/* <Testimonial /> */}
        <Articles />
        <Reviews />
        <Footer />  
    </div>
  )
}

export default App